import React, { FC } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import SummaryLabelTitle from '../../../summaryLabel/SummaryLabelTitle';
import summaryLabelStyles from '../../../summaryLabel/SummaryLabelStyles';
import SummaryLabelValue from '../../../summaryLabel/SummaryLabelValue';
import IndicativeNumber from '../../../../../../../../gqlCommon/components/indicativeNumber/IndicativeNumber';
import useScrollToSection from '../../../../../../../../customise/react/navigation/useScrollToSection';
import Translation from '../../../../../../../../common/components/translation/Translation';
import { useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../../../common/theme/ISpcTheme';

export interface ISummaryFinanceComparisonRateProps {
  percentage: number;
  percentageType: string;
  loading?: boolean;
}

const SummaryFinanceComparisonRate: FC<ISummaryFinanceComparisonRateProps> = ({ percentage, percentageType }) => {
  const styles = summaryLabelStyles();
  const { scrollToDisclaimer } = useScrollToSection();
  const { spc } = useTheme<ISpcTheme>();

  const renderComparisonLabel = () => {
    return (
      <Box display="flex" data-test="configurator:summary:comparisonRate" component="div">
        <Typography className={styles.comparisonLabel}>
          <Translation id={'trans__configurator__customise_page_finance_details__comparisonRate'} />
          <IndicativeNumber
            dataTest={'comparisonRate'}
            onClick={scrollToDisclaimer}
            displayNumber={<Translation id={'trans__configurator__indicative_numbers__comparisonRate'} />}
          />
        </Typography>
      </Box>
    );
  };

  return (
    <Grid container={true} justifyContent={'space-between'} spacing={3} className={styles.lineContainer}>
      <SummaryLabelTitle label={renderComparisonLabel()} colSm={8} colXs={6} />
      <SummaryLabelValue
        text={percentage + '%'}
        dataTest={`summary:price:${percentageType}`}
        colSm={4}
        colXs={6}
        boldText={!spc?.customise?.isFinanceComparisonRateFontWeightNormal}
      />
    </Grid>
  );
};

export default SummaryFinanceComparisonRate;
